/**
 * @desc 报表查询
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 总类型：0：环保报表 */
  totalType?: number;
  /** 类型：0：环保检测日报 1：氨水日报 2：SCR系统日报 3：环保月报 */
  type?: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.ReportDTO>> {
  return defHttp.get({
    url: '/web/report/search',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.ReportDTO>> {
  return defHttp.get({
    url: '/mock/web/report/search',

    params,
  });
}
